import React from "react";
import TooltipWrapper from "src/components/Common/TooltipWrapper";
import { getFileName } from "src/utils/common";

const FileDisplayField = ({ label, fieldName, fileData, updateInfo, status, showWarning, warningMessage }) => {
  if (!fileData) {
    return (
      <div className="row mb-1 align-items-start">
        <div className="col-md-3 p-y-8">
          <label className="form-label mb-0">{label}:</label>
        </div>
      </div>
    );
  }

  const fileName = getFileName(Array.isArray(fileData) ? fileData?.[0] : fileData);
  const displayText = `${`${fileName} (${updateInfo})`}`;

  return (
    <div className="row mb-1 align-items-start">
      <div className="col-md-3 p-y-8">
        <label className="form-label mb-0">{label}:</label>
      </div>
      <div className="col-md-9 p-t-4 p-b-8 d-flex align-items-center">
        {showWarning ? (
          <>
            <TooltipWrapper
              id={`tooltip-instance-detail-main-section-${fieldName}`}
              tooltipText={displayText || ""}
              checkOverflow={true}
              tooltipClassName="max-width-by-px-300"
            >
              <p className="mb-0 max-width-by-px-256 min-width-by-px-80 overflow-hidden text-truncate">{displayText}</p>
            </TooltipWrapper>
          </>
        ) : (
          <p className="mb-0 text-break">{displayText}</p>
        )}
        {showWarning && (
          <>
            <i className="bi text-warning bi-exclamation-triangle f-s-20 px-1" />
            <span className="text-alert">{warningMessage}</span>
          </>
        )}
      </div>
    </div>
  );
};

export default FileDisplayField;
